import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import _ from "lodash";
import shortid from "shortid";

/*- utilities -*/
function procesaItem(alumno) {
  let { actividades } = alumno;
  let data = {};

  _.forOwn(actividades, (v, k) => {
    v.alta && (data = procesarAlta(alumno, v, k, true));
    v.baja && (data = procesarAlta(alumno, v, k, false));

    if (!v.alta && !v.baja) {
      data = procesarAlta(alumno, v, k, false);
      data.alta = false;
      data.baja = false;
      data.estado = "Continúa";
    }
  });

  let actividadesOK = 0;
  data.importeFinal = 0;
  _.forOwn(data.actividades, (v, k) => {
    ++actividadesOK;
    if (!v.baja) {
      data.importeFinal =
        parseFloat(data.importeFinal) +
        parseFloat(v.precio) +
        parseFloat(v.noColegio) -
        parseFloat(v.descuento);
      !alumno.ampa && (data.importeFinal += parseFloat(v.noAmpa));
    }
    data.concepto = actividadesOK > 1 ? "V.Actividades" : v.actividad;
  });

  return data;
}

function procesarAlta(alumno, v, k, alta) {
  let datos = _.cloneDeep(alumno);
  datos.actividades[k] = v;
  datos.alta = alta;
  datos.baja = !alta;
  datos.estado = alta ? "Alta" : "Baja";
  datos.concepto = v.actividad;
  datos.importeFinal =
    parseFloat(v.precio) + parseFloat(v.noColegio) - parseFloat(v.descuento);
  !alumno.ampa && (datos.importeFinal += parseFloat(v.noAmpa));
  return datos;
}

/*- operations -*/
function obtenerListadoCobros({ idColegio, idActividad } = {}) {
  return dispatch => {
    if (_.isEmpty(idColegio) && _.isEmpty(idActividad)) {
      console.log("No hay datos de búsqueda");
    } else {
      rootRef
        .child(`cobros/general`)
        .orderByChild("idColegio")
        .equalTo(idColegio)
        .on("value", snap => {
          const datos = snap.val();
          let payload = [];
          _.forOwn(datos, (alumno, key) => {
            const a = procesaItem(alumno);
            a !== null && payload.push(a);
          });

          dispatch(actions.obtenerListadoCobros(payload));
        });
    }
  };
}

function resetListadoCobros() {
  return actions.resetListadoCobros();
}

function detachCobrosListeners() {
  return dispatch => rootRef.child("cobros/general").off();
}

function limpiarActividadSeleccionada() {
  return actions.limpiarActividadSeleccionada();
}

function putVActividadesSeleccionada() {
  const payload = { actividad: "V.Actividades" };
  return dispatch => dispatch(actions.putActividadSeleccionada(payload));
}

function putActividadSeleccionada({ idColegio, idActividad }) {
  return dispatch =>
    rootRef
      .child(`actividades_por_colegio/${idColegio}/${idActividad}`)
      .once("value", snap =>
        dispatch(actions.putActividadSeleccionada(snap.val()))
      );
}

function insertaComentario({ id, datos }) {
  let insert = {};
  insert[`cobros/general/${id}/comentarios`] = datos;
  return dispatch => rootRef.update(insert);
}

function guardarListado({ listadoCobros, detalleColegio, nombreListado }) {
  let concepto = "";
  let listado = {};
  listadoCobros.forEach(item => {
    item.estado = item.estado === "Baja" ? "No Cobrado" : "Cobrado";
    listado[shortid.generate()] = item;
    concepto = item.concepto;
  });
  const hoy = new Date();
  const listData = {
    listado,
    concepto,
    [detalleColegio.id]: detalleColegio.nombre,
    mes: hoy.getMonth(),
    fecha: hoy.getTime(),
    nota: nombreListado ? nombreListado : ""
  };

  return dispatch => {
    let raiz = "cobros/historico";
    const keyList = rootRef.child(raiz).push().key;
    let insert = {};
    insert[`${raiz}/${keyList}`] = listData;
    rootRef.update(insert, () => alert("Se ha guardado el listado"));
  };
}

/*---*/
export {
  obtenerListadoCobros,
  resetListadoCobros,
  detachCobrosListeners,
  limpiarActividadSeleccionada,
  putVActividadesSeleccionada,
  putActividadSeleccionada,
  insertaComentario,
  guardarListado
};



// WEBPACK FOOTER //
// ./src/ducks/cobros/operations.js